import { useEffect, useState } from "react";

export const useRecipeData = (recipes, id, isEditMode) => {
  const [existingRecipe, setExistingRecipe] = useState(null);

  useEffect(() => {
    if (isEditMode && id) {
      const recipe = recipes.find((r) => Number(r.id) === Number(id)) || null;
      setExistingRecipe(recipe);
    }
  }, [recipes, id, isEditMode]);

  return { existingRecipe };
};
